import editableAsyncList from "./editableAsyncList.component";

const editableAsyncListModule = angular
  .module("app.components.editableAsyncList", [])
  .component("editableAsyncList", editableAsyncList);

export default editableAsyncListModule;



// WEBPACK FOOTER //
// ./src/components/editableAsyncList/editableAsyncList.module.js